import { CitySelectInput } from "@/components/selects/CitySelectInput";
import { LocationSelectInput } from "@/components/selects/LocationSelectInput/LocationSelectInput";
import { Create, required, SimpleForm } from "react-admin";
import { useWatch } from "react-hook-form";

const EntityLocationFormContent = () => {
  const cityId = useWatch({ name: "city_id" });

  return (
    <>
      <CitySelectInput
        source="city_id"
        label="Select a City"
        validate={[required()]}
      />
      <LocationSelectInput
        source="location_id"
        label="Select a Location"
        cityId={cityId}
        isRequired={true}
      />
    </>
  );
};

const EntityLocationCreate = () => {
  return (
    <Create
      transform={(data) => {
        const { city_id, ...rest } = data;
        void city_id;
        return rest;
      }}
    >
      <SimpleForm>
        <EntityLocationFormContent />
      </SimpleForm>
    </Create>
  );
};
export default EntityLocationCreate;
